import { api } from "@/lib/api";
import { authHubOrigin } from "@/lib/atwAuthHub";

export type AtwMailGrant = { email?: string; grant: string };

/** ATW sign-in page that asks which mailboxes to connect and what Hub may do. */
export function atwMailConsentUrl(
  returnPath: "/settings/connections/mail" | "/settings/connections/calendar" = "/settings/connections/mail",
): string {
  const callback = new URL(returnPath, window.location.origin).toString();
  const url = new URL("/auth/hub-mail", `${authHubOrigin()}/`);
  url.searchParams.set("callbackUrl", callback);
  return url.toString();
}

/** Send the person to ATW to choose mailboxes and approve access. */
export function startAtwMailConnect(opts?: {
  /** Calendar tab uses the same Mail consent; Mail must be linked for Calendar. */
  returnPath?: "/settings/connections/mail" | "/settings/connections/calendar";
}): Promise<{ message?: string; email?: string }> {
  window.location.assign(atwMailConsentUrl(opts?.returnPath ?? "/settings/connections/mail"));
  return new Promise(() => {});
}

/** Store grants returned from the ATW approval page. */
export async function connectAtwMailGrants(
  grants: AtwMailGrant[],
): Promise<{ message: string }> {
  const connected: string[] = [];
  const errors: string[] = [];
  for (const item of grants) {
    const grant = item?.grant?.trim();
    if (!grant) continue;
    try {
      const result = await api<{ message?: string; email?: string; account?: { email?: string } }>(
        "/api/mail/providers/atw-mail/connect",
        {
          method: "POST",
          body: JSON.stringify({ grant }),
        },
      );
      connected.push(result.account?.email || result.email || item.email || "mailbox");
    } catch (error) {
      errors.push(error instanceof Error ? error.message : "Could not connect a mailbox.");
    }
  }
  if (!connected.length) {
    throw new Error(errors[0] || "Could not connect ATW Mail.");
  }
  const summary =
    connected.length === 1 ? `${connected[0]} is connected.` : `Connected ${connected.join(", ")}.`;
  if (errors.length) return { message: `${summary} ${errors.join(" ")}` };
  return { message: summary };
}
